import React, { HTMLAttributes } from 'react'

import { Footer } from '../footer'
import { Header } from '../header'
import { Container } from '../shared-styles'

export type LayoutProps = HTMLAttributes<HTMLDivElement> & {
  slug?: string
}

export const Layout = ({ slug, ...containerProps }) => {
  return (
    <>
      <Container {...containerProps}>
        <Header slug={slug} />
        {containerProps.children}
        <Footer slug={slug} />
      </Container>
    </>
  )
}
